class ClassTimetable {
    constructor(element) {
        this.tabs = element.querySelector(".c-class-timetable__tabs");

        this.tabs.addEventListener("click", this.handleTabClick.bind(this));
        this.tabs.addEventListener("keydown", this.handleKeyboardNavigation.bind(this));

        this.updateTabsHeight();
        this.tabs.querySelectorAll('details').forEach(detail => {
            detail.addEventListener('toggle', this.updateTabsHeight.bind(this));
        });
        window.addEventListener('resize', this.updateTabsHeight.bind(this));
    }

    handleTabClick(event) {
        if (event.target.tagName !== "SUMMARY") return;

        let targetDetails = event.target.parentElement;

        if (targetDetails.hasAttribute("open")) {
            event.preventDefault();
            return;
        }

        this.tabs.querySelectorAll("details[open]").forEach((detail) => {
            if (detail !== targetDetails) {
                detail.removeAttribute("open");
                detail.querySelector("summary").setAttribute("aria-expanded", "false");
            }
        });

        event.target.setAttribute("aria-expanded", "true");
    }

    handleKeyboardNavigation(event) {
        if (event.key === "Enter" && event.target.tagName === "SUMMARY") {
            event.target.click();
        }
    }

    updateTabsHeight() {
        const tabsContainer = document.querySelector('.c-class-timetable__tabs');
        const openContent = tabsContainer.querySelector('details[open] .c-class-timetable__content');
        
        if (openContent) {
            const contentHeight = openContent.offsetHeight + 70;
            tabsContainer.style.setProperty('--content-height', `${contentHeight}px`);
        }
    }
}

export default ClassTimetable;
